/*
 * StudyCampaignsPage
 *
 * This is the first thing users see of our App, at the '/' route
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import xhr from 'xhr.js';
import 'styles/react-kanban.css';
import styled from 'styled-components';
import { withToastManager } from 'react-toast-notifications';
import moment from 'moment-timezone';
import helpers from 'utils/helpers';

import { FiLayers, FiSend, FiUserPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import H1 from 'components/H1';
import { Flex, Box } from 'rebass';
import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';

import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import StudyPageSubNav from 'components/Study/StudyPageSubNav';

class StudyCampaignsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            study: {
                title: '',
                description: ''
            },
            campaigns: []
        };
    }

    onSwitchChange(e) {
        console.log(e);

        const study = { ...this.state.study };
        const newStatus = study.status == 'active' ? 'paused' : 'active';

        console.log(newStatus);

        study.status = newStatus;
        this.setState({ study });

        this.updateStatusXhr(newStatus);
    }

    componentDidMount() {
        xhr.get(`/studies/${this.props.match.params.id}?account_id=${this.props.auth.account.id}`, {
            withCredentials: true
        }).then(res => {
            const study = res.data;

            this.setState({
                study
            });
        });

        xhr.get(`/studies/${this.props.match.params.id}/campaigns?account_id=${this.props.auth.account.id}`, {
            withCredentials: true
        }).then(res => {
            const campaigns = res.data;

            this.setState({
                campaigns,
                loading: false
            });
        });
    }

    renderCampaigns() {
        const TimelineIconWrapper = styled.div`
            width: 32px;
            height: 32px;
            background-color: #eee;
            border-radius: 50%;
            z-index: 2;
            margin: 4px 16px 0 0;

            svg {
                margin: 5px 0 0 8px;
                color: black;
            }
        `;
        const TimelineText = styled.div`
            vertical-align: top;
            font-size: 15px;
            color: #000;

            strong {
                font-weight: 600;
            }
        `;
        const TimelineTime = styled.div`
            vertical-align: top;
            font-size: 13px;
            margin-bottom: 24px;
            color: #666;

            strong {
                font-weight: 600;
            }
        `;

        const campaigns = [];
        this.state.campaigns.forEach(c => {
            campaigns.push(
                <Flex>
                    <TimelineIconWrapper>
                        <FiSend />
                    </TimelineIconWrapper>
                    <TimelineText>
                        Email sent to {c.recipients_to_count} participant{c.recipients_to_count == 1 ? '' : 's'} by{' '}
                        <strong>{c.from_name}</strong>
                        <br />
                        <em>{c.subject}</em>
                        <TimelineTime>{moment(c.created_at).fromNow()}</TimelineTime>
                    </TimelineText>
                </Flex>
            );
        });

        if (this.state.study && this.state.study.study_people) {
            this.state.study.study_people.forEach(sp => {
                campaigns.push(
                    <Flex>
                        <TimelineIconWrapper>
                            <FiUserPlus />
                        </TimelineIconWrapper>
                        <TimelineText>
                            <Link to={`/participants/${sp.person_id}`}>
                                <strong>
                                    {helpers.personGetCustomValue(sp.person, 'First Name')}{' '}
                                    {helpers.personGetCustomValue(sp.person, 'Last Name')}
                                </strong>
                            </Link>{' '}
                            was added as a participant
                            <TimelineTime>{moment(sp.created_at).fromNow()}</TimelineTime>
                        </TimelineText>
                    </Flex>
                );
            });

            campaigns.push(
                <Flex>
                    <TimelineIconWrapper>
                        <FiLayers />
                    </TimelineIconWrapper>
                    <TimelineText>
                        <strong>{this.state.study.user.email}</strong> created the study
                        <TimelineTime>{moment(this.state.study.created_at).fromNow()}</TimelineTime>
                    </TimelineText>
                </Flex>
            );
        }

        return campaigns;
    }

    render() {
        return (
            <Flex style={{ width: '100%' }}>
                <StudyPageSubNav study_id={this.props.match.params.id} study={this.state.study} />
                <AppPageWrapper>
                    <Helmet>
                        <title>{this.state.study.title}</title>
                    </Helmet>

                    <AppPageWrapperSectionHeader>
                        <H1>Activity (This page is not displaying all relevant data yet)</H1>
                    </AppPageWrapperSectionHeader>

                    <AppPageWrapperSectionBody>
                        {this.state.loading ? (
                            <div style={{ width: '100%' }}>
                                <LoadingWrapper>
                                    <LoadingIndicator />
                                </LoadingWrapper>
                            </div>
                        ) : (
                            <Box mx={4} my={2} sx={{ position: 'relative' }}>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '16px',
                                        top: 0,
                                        bottom: 0,
                                        width: '1px',
                                        background: '#eee'
                                    }}
                                ></Box>
                                <Box sx={{ marginTop: '24px' }}>{this.renderCampaigns()}</Box>
                            </Box>
                        )}
                    </AppPageWrapperSectionBody>
                </AppPageWrapper>
            </Flex>
        );
    }
}

export default withToastManager(StudyCampaignsPage);
